import React from "react"

const Magento = ({ ...props }) => {
	return (     
            <svg {...props} width="303px" height="303px" viewBox="-23.5 0 303 303" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                <path d="M144.852 90.67v172.192l-16.933 10.349-16.946-10.404V90.803l-43.878 27.016v147.255l60.824 37.217 61.339-37.482V117.725L144.852 90.67zM127.919 0L0 77.502v147.274l33.223 19.572V97.06l94.722-57.596 94.81 57.512.391.223-.042 146.929L256 224.776V77.502L127.919 0z" fill="#fff"/>
            </svg>
	)
}

export default Magento
